import React from "react";
import { LoadingOutlined } from "@ant-design/icons";
import { Col, Result, Row, Space, } from "antd";
import { useIntl } from "react-intl";

import "./StoreLoading.less";
import { StoreCard } from "toolkit/card/StoreCard";

export function StoreLoading() {
  const intl = useIntl();
  const icon = (
    <LoadingOutlined
      style={{ fontSize: 72 }}
      spin
    />
  );

  return (
    <StoreCard className="store-loading">
      <Row
        className="store-loading__content"
        justify="space-around"
        align="middle"
      >
        <Col>
          <Space
            align="center"
            direction="vertical"
          >
            <Row
              className="store-loading__content"
              justify="center"
              align="middle"
            >
              <Col>
                <Result
                  icon={icon}
                  title={intl.formatMessage({ id: "jmix-store.loading.title" })}
                />
              </Col>
            </Row>
          </Space>
        </Col>
      </Row>
    </StoreCard>
  );
}
